import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "card-deck" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = { class: "table table-bordered table-hover" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-danger" }
const _hoisted_20 = { class: "modal-footer d-flex justify-content-between" }

import { computed, toRef } from 'vue'

    import type {
        AlternativeAttributeValueChangeReadModel,
        AttributeReadModel
    } from '@Evaluation/ValueAnalysis/Domain/readmodels'

    import type { SaveToAttributeDialogViewModel } from '@Evaluation/ValueAnalysis/Components/SaveToAttributeDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SaveToAttributeDialog',
  props: {
    viewModel: {}
  },
  emits: ["save-existing-attribute", "save-new-attribute"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const saving = computed(() => vm.value.saving)

    const allAttributes = computed<AttributeReadModel[]>(() => vm.value.attributes)

    const attributes = computed<AttributeReadModel[]>(() =>
        allAttributes.value.filter(a =>
            a.IsNumeric === true &&
            a.IsManual === true &&
            a.IsMultivalue === false
        )
    )

    const duplicatedName = computed<boolean>(() =>
        allAttributes.value.some(a =>
            a.Name.toLowerCase() === vm.value.newAttributeName?.toLowerCase()
        )
    )

    const attributeName = computed<string>(() =>
        useExistingAttribute.value === true
            ? existingAttribute.value?.Name ?? ''
            : newAttributeName.value
    )

    const changes = computed<AlternativeAttributeValueChangeReadModel[]>(() =>
        vm.value.changes
    )

    // ---------------- writable computed (VM-backed) ----------------

    const step = computed<string>({
        get: () => vm.value.step,
        set: val => { vm.value.step = val }
    })

    const newAttributeName = computed<string>({
        get: () => vm.value.newAttributeName,
        set: val => { vm.value.newAttributeName = val }
    })

    const existingAttribute = computed<AttributeReadModel | null>({
        get: () => vm.value.existingAttribute,
        set: val => { vm.value.existingAttribute = val }
    })

    const useExistingAttribute = computed<boolean>({
        get: () => vm.value.useExistingAttribute,
        set: val => { vm.value.useExistingAttribute = val }
    })

    // ---------------- actions ----------------

    function saveChanges()
    {
        const values = changes.value
            ?.filter(a => a.NewValue != null)
            .map(a => `${a.Id}:${a.NewValue}`) ?? []

        if (useExistingAttribute.value === true)
        {
            if (!existingAttribute.value) return

            emit(
                'save-existing-attribute',
                existingAttribute.value.Id,
                values
            )
        }
        else
        {
            emit(
                'save-new-attribute',
                newAttributeName.value,
                values
            )
        }
    }

    function showStart()
    {
        step.value = 'start'
        vm.value.changes = null
    }

    function showPreview()
    {
        if (useExistingAttribute.value === true && existingAttribute.value == null)
        {
            return
        }

        const attrId = useExistingAttribute.value === true
            ? existingAttribute.value!.Id
            : null

        step.value = 'preview'
        vm.value.showChanges(attrId)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (step.value === 'start')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "modal-title" }, "Save to attribute", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card", {'border-primary' : useExistingAttribute.value === false }])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card-header pointer", {'text-white bg-primary' : useExistingAttribute.value === false }]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (useExistingAttribute.value = false))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa-regular", {'fa-square': useExistingAttribute.value === true, 'fa-square-check': useExistingAttribute.value === false}]),
                            "aria-hidden": "true"
                          }, null, 2 /* CLASS */),
                          _cache[5] || (_cache[5] = _createTextVNode(" Create new attribute ", -1 /* CACHED */))
                        ], 2 /* CLASS */),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newAttributeName).value = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [
                                _vModelText,
                                newAttributeName.value,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (duplicatedName.value === true)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_9, "Sorry, this name is already being used. Please change the name to a unique name."))
                              : _createCommentVNode("v-if", true),
                            _cache[6] || (_cache[6] = _createElementVNode("small", { class: "form-text text-muted" }, "Values will be saved as a new attribute in \"Value scores\" section.", -1 /* CACHED */))
                          ])
                        ])
                      ], 2 /* CLASS */),
                      _createElementVNode("div", {
                        class: _normalizeClass(["card", {'border-primary' : useExistingAttribute.value === true}])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["card-header pointer", {'text-white bg-primary' : useExistingAttribute.value === true }]),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (useExistingAttribute.value = true))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa-regular", {'fa-square': useExistingAttribute.value === false, 'fa-square-check': useExistingAttribute.value === true}]),
                            "aria-hidden": "true"
                          }, null, 2 /* CLASS */),
                          _cache[7] || (_cache[7] = _createTextVNode(" Use existing attribute ", -1 /* CACHED */))
                        ], 2 /* CLASS */),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((existingAttribute).value = $event)),
                              class: "form-control"
                            }, [
                              _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "Choose...", -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                                return (_openBlock(), _createElementBlock("option", { value: attr }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_12))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                              [_vModelSelect, existingAttribute.value]
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("small", { class: "form-text text-muted" }, " Values will be saved to the existing attribute. ", -1 /* CACHED */))
                          ])
                        ])
                      ], 2 /* CLASS */)
                    ])
                  ]),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      onClick: showPreview,
                      type: "button",
                      class: "btn btn-primary"
                    }, "Preview"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: close
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (step.value === 'preview')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "modal-title" }, "Preview", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("table", _hoisted_15, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(attributeName.value), 1 /* TEXT */),
                          _cache[11] || (_cache[11] = _createElementVNode("th", null, "Value", -1 /* CACHED */))
                        ])
                      ]),
                      (changes.value)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changes.value, (a) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: a.Id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(a.Name), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_17, [
                                  _createElementVNode("span", null, _toDisplayString(a.NewValue), 1 /* TEXT */),
                                  (a.OldValue != null)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_18, [
                                        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                        _cache[13] || (_cache[13] = _createTextVNode(" (Current: ", -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_19, _toDisplayString(a.OldValue), 1 /* TEXT */),
                                        _cache[14] || (_cache[14] = _createTextVNode(") ", -1 /* CACHED */))
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary",
                      onClick: showStart
                    }, "Back"),
                    _createElementVNode("div", null, [
                      (saving.value === true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: saveChanges
                          }, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                            _createTextVNode(" Saving... ", -1 /* CACHED */)
                          ]))]))
                        : _createCommentVNode("v-if", true),
                      (saving.value === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary",
                            onClick: saveChanges
                          }, "Save"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary",
                        onClick: close
                      }, "Cancel")
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})